import { AvailabilityStateType } from '@src/constants/AvailabilityState';
import useApi, { ApiOptions } from '../base/useApi';

export interface Params {
  date: Date;
  state: AvailabilityStateType;
}

export interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/user/availability_state/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: true,
  useGCKey: true,
};

export const useSaveAvailabilityLazy = (params?: Params) => {
  return useApi<Params, Result>(options, params);
};

export default useSaveAvailabilityLazy;
